<script>
    // import { getCSSVar } from '$lib/utils'
    import logo from '../../../assets/logo-header.svg'
    import { BurgerMenu, Close } from '../Icons/custom'
    import { clickOutsideParent } from '$lib/utils'
    import { createEventDispatcher } from 'svelte'
    import { BackDrop, ScrollBox, Avatar } from '../UI/'
    import slide from '../../custom/animations/slide'
    import Footer from '../../../views/Footer.svelte'
    export let background = 'white'
    export let style = ''
    export let isOpen = true
    export let title = null
    const dispatch = createEventDispatcher()
    function toggle() {
        isOpen = !isOpen
    }
    function onClickLogo() {
        dispatch('clicklogo')
    }
</script>

<div class="container bg-{background}">
    <div class="header">
        {#if $$slots.sideMenu}
            <div class="burgerIcon" on:click={toggle} class:active={isOpen}>
                <svelte:component this={isOpen ? Close : BurgerMenu} />
            </div>
        {/if}
        <span style="display: flex; gap: 8px">
            <span on:click={onClickLogo} style="cursor: pointer;">
                <img draggable="false" class="logo" src={logo} alt="" />
            </span>
            {#if title}
                <p>{title}</p>
            {/if}
        </span>
        <div class="leftSpace"><slot name="leftSpace" /></div>
    </div>
    <div class="content" {style}>
        <BackDrop
            style="position: fixed; padding: 70px 0 0 0; z-index: var(--lvl-3)"
            bind:visible={isOpen}
        >
            <div
                transition:slide={{ duration: 300 }}
                use:clickOutsideParent
                on:clickout={(_) => (isOpen = false)}
                class="menu"
            >
                <slot name="sideMenu" />
            </div>
        </BackDrop>
        <slot />
    </div>
    <!-- <div class="footer">
        <Footer />
    </div> -->
</div>

<style>
    .container {
        display: grid;
        grid-template-rows: 70px 1fr auto;
        width: 100%;
        min-height: 100%;
        position: absolute;
    }
    .content {
        grid-row: 2;
        overflow: auto;
        width: 100%;
        min-height: calc(100% - 70px);
        height: auto;
        /* display: flex; */
        display: flex;
        flex-direction: column;
        /* align-items: center;
        justify-content: center; */
        position: relative;
    }
    .header {
        height: 70px;
        width: 100%;
        grid-row: 1;
        position: fixed;
        top: 0;
        background: var(--color-brand-primary-01);
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        left: 0;
        z-index: var(--lvl-4);
    }
    .header p {
        color: white;
        margin-left: 5px;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 21px;
    }
    .logo {
        user-select: none;
        height: 56px;
        width: auto;
        /* align-self: center; */
        justify-self: center;
        position: relative;
    }

    .burgerIcon {
        position: absolute;
        left: 0;
        justify-self: flex-start;
        align-self: flex-start;
        width: 70px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: transparent;
        cursor: pointer;
        transition: background-color 0.2s ease-in-out;
    }
    .menu {
        position: absolute;
        top: 70px;
        display: flex;
        transform: translateY(0px);
        left: 0px;
        /* height: calc(100vh - 70px); */
        height: 100%;
        background-color: var(--color-brand-primary-01);
    }

    .burgerIcon:hover,
    .active {
        background-color: var(--color-accent-01);
    }

    .leftSpace {
        position: absolute;
        right: 25px;
        /* background: rgba(0,0,0,0.1); */
    }

    .bg-grey {
        background-color: var(--color-grey-050);
    }
    .bg-white {
        background-color: var(--color-white);
    }
    .footer {
        position: relative;
        grid-row: 3;
    }
</style>
